export type WeaponKey = "chaingun" | "autocannon" | "howitzer";

export type WeaponMods = {
  cooldownMult: number;
  spreadMult: number;
  blastRadiusMult: number;
  tracerBright: boolean;
};

export type LoadoutMods = Record<WeaponKey, WeaponMods>;

export const DEFAULT_WEAPON_MODS: WeaponMods = {
  cooldownMult: 1,
  spreadMult: 1,
  blastRadiusMult: 1,
  tracerBright: false,
};

export const DEFAULT_LOADOUT: LoadoutMods = {
  chaingun: { ...DEFAULT_WEAPON_MODS },
  autocannon: { ...DEFAULT_WEAPON_MODS },
  howitzer: { ...DEFAULT_WEAPON_MODS },
};

// Weapon stat aggregation lives in meta/field-mods.ts (computeRunModifiers);
// this module only owns the shape the weapons consume.
